import { render, staticRenderFns } from "./ChatDeSuporte.vue?vue&type=template&id=3fa872e5&scoped=true&"
import script from "./ChatDeSuporte.vue?vue&type=script&lang=ts&"
export * from "./ChatDeSuporte.vue?vue&type=script&lang=ts&"
import style0 from "./ChatDeSuporte.vue?vue&type=style&index=0&id=3fa872e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa872e5",
  null
  
)

export default component.exports